import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

// components
import { Button } from 'components/shard'

// const
import { Size, Color } from 'const'

import { useTanakaIdHook } from 'hooks'

function TanakaIdConfirm() {
  const history = useHistory()
  const { successes, errors, isRequestingAPI, confirmTanakaId } = useTanakaIdHook()

  // マウント時のみ実行
  useEffect(() => {
    confirmTanakaId()
  }, [confirmTanakaId])

  if (isRequestingAPI) {
    return (
      <Wrapper>
        <Title>TANAKA-IDの存在確認中。</Title>
      </Wrapper>
    )
  } else {
    if (errors.length === 0) {
      return (
        <Wrapper>
          <Title>TANAKA-IDの存在確認完了</Title>
          <Message>
            {successes.join('\n')}
            <br />
            ご契約者の場合、マイページにログインし、NINALご契約のお客様は、決済情報を入力してください。
          </Message>
          <ButtonWrapper>
            <Button
              type={'submit'}
              primary
              onClick={() => {
                history.push('/login')
              }}
            >
              マイページ
            </Button>
          </ButtonWrapper>
        </Wrapper>
      )
    } else {
      return (
        <Wrapper>
          <Title>TANAKA-IDの存在確認失敗</Title>
          <Message>
            お客様のTANAKA-IDの存在確認が失敗しました。
            <br />
            {errors.join('\n')}
          </Message>
          <ButtonWrapper>
            <Button
              type={'submit'}
              primary
              onClick={() => {
                history.push('/login')
              }}
            >
              マイページ
            </Button>
          </ButtonWrapper>
        </Wrapper>
      )
    }
  }
}

const Wrapper = styled.div`
  display: grid;
  grid-template-rows: 100px 50px 50px 1fr;
`

const Title = styled.div`
  grid-row: 2;
  display: flex;
  align-items: flex-end;
  font-size: ${Size.FONT.HEADLINE.LEARGE};
  padding-bottom: 20px;
  border-bottom: 1px solid ${Color.LINE.NORMAL};
`

const Message = styled.div`
  grid-row: 3;
  padding: 8px 0;
  color: ${Color.FONT.ANNOTATION};
  padding-top: 30px;
`

const ButtonWrapper = styled.div`
  grid-row: 4;
  display: flex;
  justify-content: center;
  padding-top: 100px;
`

TanakaIdConfirm.propTypes = {
  values: PropTypes.object,
  dirty: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitLogin: PropTypes.func,
}

export default TanakaIdConfirm
